import {HttpClient} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {Observable, throwError} from "rxjs";
import {map, tap} from "rxjs/operators";
import {
  Role,
  SituazioneRuoliResponse,
  SituazioneRuoli,
  AddRoleResponse,
  RolePermissionResponse, RolePermission
} from "@modules/roles/roles.interface";
import {environment} from "@env/environment";
import {response} from "express";

@Injectable({
  providedIn: 'root'
})
export class RolesHttpService {

  constructor(
    private http: HttpClient
  ) { }

  findAllRoles(): Observable<SituazioneRuoli> {
    return this.http.get<SituazioneRuoliResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/situazioneRuoli`).pipe(
      map(response => response.data)
    );
  }

  deleteRole(id: string) {
    return this.http.get(`${environment.DASHBOARD_PRIVATE_BASE_URL}/eliminaRuolo/${id}`);
  }

  addRole(request): Observable<Role> {
    return this.http.post<AddRoleResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/aggiungiRuolo`, request).pipe(
        map(response => response.data)
    )
  }

  updateRole(request): Observable<Partial<Role>> {
    return this.http.post<AddRoleResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/aggiornaRuolo`, request)
      .pipe(
        map(response => response.data),
        map(response => {
          return {
            id_ruolo: response.id_ruolo,
            ruolo: response.ruolo
          }
        })
      )
  }

  addPermissionToRole(request): Observable<RolePermission> {
    return this.http.post<RolePermissionResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/aggiungiPermessoARuolo`, request)
      .pipe(
        map(response => response.data.ruoloPermesso)
      )
  }

  removePermissionFromRole(request): Observable<Role> {
    return this.http.post(`${environment.DASHBOARD_PRIVATE_BASE_URL}/rimuoviPermessoDaRuolo`, request)
      .pipe(
        tap(risposta => {
          if (risposta['codice'] !== '000') {
            throwError("Si è verificato un errore in fase di rimozione di un permesso dal ruolo");
          }
        }),
        map(response => request)
      );
  }
}
